<template>
  <div class="a-loading-primary">
    <img
      alt="loading"
      src="@/assets/loading/a-loading-primary.svg"
    />
    <p v-show="showLoadingText">
      <span v-if="loadingText.length">
        {{ loadingText }}
      </span>
      <span v-else>
        {{ $t('aLoadingPrimary.message') }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'AtomLoadingPrimary',

  props: {
    loadingText: {
      type: String,
      default: ''
    },

    showLoadingText: {
      type: Boolean,
      default: true
    },

    svgLoading: {
      type: String,
      default: 'academy'
    }
  }
}
</script>
